import type { ContentReplaceModifier } from '@carboncopyco/types';
import { useElementSize } from '../../hooks';
import { Label } from '../FormField';
import { DynamicResponseModifiersList } from './DynamicResponseModifiersList';
import { DynamicResponseModifiersPreview } from './DynamicResponseModifiersPreview';

export type DynamicResponseModifier = ContentReplaceModifier & {
  id: string;
};

export type CreateDynamicResponseProps = {
  response: string;
  hidePreview?: boolean;
};

export const CreateDynamicResponse = ({
  response,
  hidePreview,
}: CreateDynamicResponseProps) => {
  const [containerRef, { height }] = useElementSize();

  return (
    <div className="flex flex-col gap-1.5 flex-1 min-h-0">
      <div className="flex">
        <div className="flex basis-1/2">
          <Label label="Conditions" />
        </div>
        {!hidePreview && <Label label="Preview" />}
      </div>
      <div className="flex flex-1 rounded-md border border-ds-natural-150 min-h-0">
        <div className="flex-1 border-r border-ds-natural-150">
          <DynamicResponseModifiersList />
        </div>
        {!hidePreview && (
          <div
            className="flex overflow-hidden flex-1"
            ref={containerRef}
          >
            <DynamicResponseModifiersPreview
              height={height}
              response={response}
            />
          </div>
        )}
      </div>
    </div>
  );
};
